<template>
    <div id="bottom" :class="user.loginname?'isShow':''">
        <span>{{$t("trade.bottom.explain")}}</span>
        <a v-if="!user.loginname" @click="login()">{{$t("trade.bottom.login")}}</a>
    </div>
</template>
<script>
    import {mapState} from 'vuex'

    export default {
        name: "Bottom",
        computed: {
            ...mapState(['user'])
        },
        methods: {
            login() {
                this.$bus.$emit('loading', false);
                this.$router.push({path: '/Login'});
            }
        }
    }
</script>
